<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" v-shortkey="['esc']" @shortkey="cerrar" variant="danger"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <form @submit.prevent="guardar_formula">

                    <b-row>
                        <div class="col-sm-12 mt-1">
                            <h3>
                                Formulario promoción
                            </h3>
                        </div>
                        <div class="col-sm-12 mt-2">
                            <label for="" class="form-label">Código promoción</label>
                            <input type="text" id="campo_promocion_formula" required autocomplete="off"
                                class="form-control form-control-sm" v-model="codigo_promocion">
                        </div>

                        <div :class="ES_ROOT ? `col-sm-6 mt-3` : `col-sm-9 mt-3`">
                            <label for="" class="form-label">Nombre de la promoción</label>
                            <input type="text" class="form-control form-control-sm" required v-model="nombre_formula">
                        </div>

                        <div v-if="ES_ROOT" class="col-sm-3 mt-3">
                            <label for="" class="form-label">Sucursal asginada</label>
                            <select class="form-control form-control-sm" required v-model="sucursal"
                                @change="setear_sucursal_origen">
                                <option value="">Seleccionar</option>
                                <option v-for="(item, index) in SUCURSALES_SIN_BODEGA_CENTRAL" :key="index"
                                    :value="item.codigo">
                                    {{ item.nombre }}</option>
                            </select>
                        </div>
                        <!-- <div class="col-sm-3 mt-3">
                        <label for="" class="form-label">Precio Costo</label>
                        <input type="number" step="0.01" min="0" class="form-control form-control-sm"
                            v-model="precio_costo">
                    </div> -->
                        <div class="col-sm-3 mt-3">
                            <label for="" class="form-label">Precio Venta</label>
                            <input type="number" step="0.01" min="0" required class="form-control form-control-sm"
                                v-model="precio_venta">
                        </div>
                        <div class="col-sm-8 mt-3">
                            <label for="" class="form-label">Código producto</label>
                            <input type="text" list="productos_" :disabled="FILTRAR_PRODUCTOS_POR_SUCURSAL.length === 0"
                                autocomplete="off" id="campo_codigo_producto_formula"
                                class="form-control form-control-sm" v-model="codigo">
                            <datalist id="productos_">
                                <option v-for="(item, index) in FILTRAR_PRODUCTOS_POR_SUCURSAL" :key="index"
                                    :value="item.codigo">{{
                                        item.nombre
                                    }}</option>
                            </datalist>
                        </div>

                        <div class="col-sm-2 mt-3">
                            <label for="" class="form-label">Cantidad</label>
                            <input type="number" class="form-control form-control-sm" v-model="cantidad">
                        </div>

                        <div class="col-sm-2 mt-5">
                            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                                @click="agregar_producto_a_lista">Agregar</button>
                        </div>

                        <div class="col-sm-12 mt-3">
                            <div class="contenedor_lista_articulos_para_combo">
                                <table class="table table-sm table-striped table-bordered" style="font-size: 11px;">
                                    <thead>
                                        <tr>
                                            <th style="width: 15%;">
                                                Código
                                            </th>
                                            <th style="width: 65%;">
                                                Descripción
                                            </th>
                                            <th style="width: 10%;text-align: center;">
                                                Cantidad
                                            </th>
                                            <th style="width: 10%;text-align: center;">
                                                ...
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in listado" :key="index">
                                            <td>
                                                {{ item.codigo }}
                                            </td>
                                            <td>
                                                {{ item.descripcion }}
                                            </td>
                                            <td style="text-align: center;">
                                                {{ item.cantidad }}
                                            </td>
                                            <td style="text-align: center;">
                                                <b-button type="button" size="sm" style="font-size: 9px;"
                                                    variant="outline-dark" @click="eliminar_fila(index)"><i
                                                        class="fas fa-trash"></i></b-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3 mb-3">
                            <button type="submit" class="btn btn-sm btn-outline-dark btn-block">Guardar</button>
                        </div>
                    </b-row>
                </form>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'ListadoFormulas',
        computed: {
            ...mapState(['datos_usuario']),
            ...mapGetters(['ES_ROOT', 'SUCURSALES_SIN_BODEGA_CENTRAL', 'FILTRAR_PRODUCTOS_POR_SUCURSAL'])
        },
        data() {
            return {
                listado: [],
                codigo_promocion: '',
                cantidad: 1,
                nombre_formula: '',
                sucursal: '',
                precio_costo: '',
                precio_venta: '',
                codigo: '',
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            agregar_producto_a_lista() {

                if (this.codigo == '' || this.cantidad == '') {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })

                } else {

                    let i = this.FILTRAR_PRODUCTOS_POR_SUCURSAL.findIndex(item => item.codigo == this.codigo)

                    let f = {
                        codigo: this.codigo,
                        descripcion: this.FILTRAR_PRODUCTOS_POR_SUCURSAL[i].nombre,
                        cantidad: this.cantidad <= 0 ? 1 : this.cantidad == '' ? 1 : this.cantidad,
                    }

                    this.listado.push(f)
                    document.getElementById('campo_codigo_producto_formula').focus()

                    this.codigo = ''
                    this.cantidad = ''
                }
            },
            eliminar_fila(index) {
                this.listado.splice(index, 1)
            },
            async guardar_formula() {
                if (this.codigo_promocion == '' || this.nombre_formula == '' || this.precio_venta == '') {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                } else {
                    if (this.listado.length == 0) {
                        minix({ icon: 'error', mensaje: 'La formula debe tener al menos un producto', tiempo: 3000 })
                    } else {

                        let f = {
                            api: 'articulos/r/formulas',
                            formulario: {
                                codigo: this.codigo_promocion.trim(),
                                nombre_formula: this.nombre_formula,
                                productos: this.listado,
                                // precio_costo: this.precio_costo,
                                sucursal: this.ES_ROOT ? this.sucursal : this.datos_usuario.sucursal_asignada,
                                precio_venta: this.precio_venta
                            }
                        }

                        await this.guardar_data(f)
                        await this.obtener_articulos()

                        this.nombre_formula = ''
                        // this.precio_costo = ''
                        this.precio_venta = ''
                        this.sucursal = ''
                        this.listado = []
                    }
                }

            },
            setear_sucursal_origen() {
                // ESTO ES PARA QUE FILTRE LOS PRODUCTOS POR SUCURSAL
                this.set_filtro_productos_sucursales_traslados(parseInt(this.sucursal))

            },
            ...mapActions(['guardar_data', 'obtener_articulos']),
            ...mapMutations(['set_filtro_productos_sucursales_traslados'])
        },
        mounted() {
            document.getElementById('campo_promocion_formula').focus()
        },

    }
</script>

<style>
    .contenedor_lista_articulos_para_combo {
        width: 100%;
        height: 250px;
        border: 1px solid #e9e9e9;
        overflow: auto;
    }
</style>